export enum IncludeCompanyType {
  CONNECTIS,
  ASISTERA,
  CONNECTIS_ASISITERA
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/clause/include-company-type.enum.ts